<template>
  <div class="paper-manage">
    <div class="paper-manage-header">
      <div class="title">《{{ lib.name }}》 专有词</div>
    </div>
    <div class="back" @click="goBack"><img src="@imgs/back-icon.png" />返回专有词库</div>
    <div class="btn-wrapper">
      <div class="create-btn" @click="addWord">添加专有词</div>
    </div>
    <List class="questionnaire-list" @flipPage="flipPage" :totalCount="totalCount" :currentPage="currentPageNo" :pageSize="20">
      <template v-slot:listContent>
        <div class="paper-list-content">
          <el-table :data="tableData" border style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
            <el-table-column prop="word" label="专有词" min-width="100"></el-table-column>
            <el-table-column label="操作" min-width="180">
              <template slot-scope="scope">
                <div class="option-button" @click="editItem(scope.row)">编辑专有词</div>
                <div class="option-button" @click="deleteItem(scope.row)">删除专有词</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </List>
    <tip-dialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" @clickConfirm="clickDeleteConfirm"></tip-dialog>
    <add-tip-dialog ref="addDialog" :dialogOptions="buildDialogOptions" @clickConfirm="clickBuildConfirm"></add-tip-dialog>
    <add-tip-dialog ref="editDialog" :dialogOptions="editDialogOptions" @clickConfirm="clickEditConfirm"></add-tip-dialog>
  </div>
</template>
<script>
import List from '@components/list/listFrame'
import AddTipDialog from '@components/common/AddTipDialog.vue'
import TipDialog from '../../common/TipDialog'
import compareVipRight from '@components/common/compareVipRight.js'
import api from '@api/specialWord'
export default {
  name: 'WordList',
  mixins: [compareVipRight],
  data() {
    return {
      totalCount: 0,
      currentPageNo: 1,
      tableData: [],
      currentEdit: {},
      deleteId: '',
      showEdit: false,
      buildDialogOptions: {
        // 弹框类型
        type: 'build',
        // 弹框头部标题
        title: '添加专有词',
        // 弹框内容
        label: '请输入专有词：',
        value: '',
        message: '请填写20字以内专有词'
      },
      editDialogOptions: {
        // 弹框类型
        type: 'build',
        // 弹框头部标题
        title: '编辑专有词',
        // 弹框内容
        label: '请输入专有词：',
        value: '',
        message: '请填写20字以内专有词'
      },
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '是否确定删除，删除后不可恢复。'
      }
    }
  },
  props: {
    lib: {
      type: Object
    }
  },
  computed: {
    userName() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    getWordList() {
      const param = {
        libId: this.lib.id,
        pageNo: this.currentPageNo,
        pageSize: 20
      }
      api.getSpecificWordByPage(param).then(async (res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.tableData = res.data.data.content
          this.totalCount = res.data.data.totalElements
        } else {
          this.tableData = []
        }
      })
    },
    flipPage(pageNo) {
      this.currentPageNo = pageNo
      this.getWordList()
    },
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0) {
        return 'text-align: center'
      }
    },
    addWord() {
      if (this.totalCount >= 1000) {
        this.$message({
          message: '该专有词库已满1000个专有词，请删除后再添加',
          type: 'warning'
        })
        return
      }
      this.$refs.addDialog.visible = true
    },
    deleteItem(item) {
      this.deleteId = item.id
      this.$refs.deleteDialog.visible = true
    },
    clickDeleteConfirm() {
      let param = {
        id: this.deleteId
      }
      api.delSpecificWord(param).then((res) => {
        if (res.data.status === 0) {
          this.getWordList()
        } else {
          this.$message({
            message: res.data.message || '删除失败',
            type: 'error'
          })
        }
      })
    },
    clickEditConfirm(val) {
      if (val.lenght > 20) {
        this.$message({
          message: '请填写20字以内专有词',
          type: 'error'
        })
      }
      const param = {
        id: this.currentEdit.id,
        word: val
      }
      api.editSpecificWord(param).then((res) => {
        if (res.data.status === 0) {
          this.getWordList()
        } else {
          this.$message({
            message: res.data.message || '修改失败',
            type: 'error'
          })
        }
      })
    },
    clickBuildConfirm(val) {
      const param = {
        word: val,
        libId: this.lib.id
      }
      api.addSpecificWord(param).then((res) => {
        if (res.data.status === 0) {
          this.getWordList()
        } else {
          this.$message({
            message: res.data.message || '创建失败',
            type: 'error'
          })
        }
      })
    },
    editItem(item) {
      this.currentEdit = item
      this.editDialogOptions.value = item.word
      this.$refs.editDialog.visible = true
    },
    goBack() {
      this.$emit('goBack')
    }
  },
  async created() {
    await this.getWordList()
  },
  components: {
    AddTipDialog,
    TipDialog,
    List
  },
  watch: {}
}
</script>
<style lang="scss" scoped>
.paper-manage {
  width: 100%;
  position: relative;
  .paper-manage-header {
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .back {
    font-size: 14px;
    line-height: 26.06px;
    color: #df5813;
    position: absolute;
    right: 30px;
    top: 10px;
    cursor: pointer;
    img {
      width: 16px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  .btn-wrapper {
    display: flex;
    .create-btn {
      width: 140px;
      height: 30px;
      font-weight: 500;
      color: #ffffff;
      line-height: 30px;
      background-color: #df5813;
      border-radius: 3px;
      text-align: center;
      cursor: pointer;
      margin-left: 20px;
    }
  }
  a.updateContent {
    color: unset;
    text-decoration: none;
  }
  .option-button {
    display: inline-block;
    cursor: pointer;
    color: #df5813;
    margin-right: 20px;
  }
  .no-pointer-wrapper {
    .option-button {
      pointer-events: none;
      color: #9b9aa7;
    }
  }
}
</style>
<style lang="scss">
.lib-manage-wrapper {
  .build-dialog {
    .el-dialog {
      .el-dialog__body {
        label {
          width: 145px;
        }
        .el-input {
          width: 240px;
        }
      }
    }
  }
}
.add-tip {
  .el-dialog {
    .el-dialog__body {
      .dialog-input-container {
        label {
          font-size: 12px;
          color: #515151;
        }
        .el-input {
          width: 250px;
        }
      }
    }
  }
}
</style>
